module.exports = __webpack_public_path__ + "static/media/icon-MOBILE.a843b866.svg";